import moment from 'moment'
import { gqlQuery, gqlMutate } from './common/apolloClient'
import { gqlResumo, resumoTransform } from './queries/resumo'
import { gqlRecharges, transformRecharges } from './queries/recharges'
import {
  gqlInvoices,
  gqlDownloadFaturaPdf,
  gqlDownloadFaturaCsv,
  gqlDownloadBoleto
} from './queries/invoices'
import {
  gqlListPlateFilters,
  gqlCreatePlateFilter,
  gqlUpdatePlateFilter,
  gqlDeletePlateFilter,
  gqlExtrato,
  transformExtrato,
  gqlDownloadExtratoCsv,
  gqlDownloadExtratoPdf,
  gqlSendStatementEmail,
  gqlResendStatement
} from './queries/transactions'
import {
  gqlIdentificadores,
  gqlIdentificador,
  gqlDownloadIdentificadoresCsv,
  transformIndentificadores
} from './queries/vehicles'
import { getTipoTransacao, downloadBase64 } from './common/helpers'
import { gqlPlanData } from './queries/plans'

export * from '../services-middleware/dashboardService'

export async function getPlanResume(planId) {
  const resumo = resumoTransform(await gqlQuery(gqlResumo, { idConta: planId }), planId)
  return resumo
}

export async function getInvoices(planId, next) {
  const proxima = next || 1

  const payload = { idConta: planId, page: proxima }
  const { data = {} } = await gqlQuery(gqlInvoices, payload)

  const { historicoFaturas = {} } = data
  const { paginacao = {} } = historicoFaturas

  const response = {
    ...historicoFaturas,
    paginacao: paginacao.proxima ? paginacao : {}
  }

  return response
}

export async function getRecharges(planId, _next) {
  const next = _next || 0
  const payload = { idConta: planId, skip: next }
  const { data = {} } = await gqlQuery(gqlRecharges, payload)

  const { historicoRecargas: { remaining = 0, recargas = [] } = {} } = data
  const recharges = transformRecharges(recargas)

  const response = {
    data: recharges,
    next: remaining ? next + recargas.length : null,
    totalCount: next + recargas.length + remaining
  }

  return response
}

export async function getPlateFilters(planId, type) {
  const result = await gqlQuery(gqlListPlateFilters, {
    conta: planId,
    tipo: type
  })

  return {
    data: result.data.listaFiltro || []
  }
}

export async function addPlateFilter(filter) {
  const result = await gqlMutate(gqlCreatePlateFilter, {
    filtro: filter
  })

  return {
    data: result.data.inserirFiltro
  }
}

export async function updatePlateFilter({ id, ...filterData }) {
  const result = await gqlMutate(gqlUpdatePlateFilter, {
    filtro: filterData,
    id
  })

  return {
    data: result.data.alterarFiltro
  }
}

export async function deletePlateFilter(planId, filterId) {
  const result = await gqlMutate(gqlDeletePlateFilter, {
    conta: planId,
    id: filterId
  })

  return {
    data: result.data.deletarFiltro
  }
}

export async function getStatements(planId, next, filter = {}) {
  let pagina = (next && next.pagina) || 1
  const portalParceiro = 'true'
  const hasRangeDates = filter.rangeDates && filter.rangeDates.from && filter.rangeDates.to
  const QTD = 30
  const gqlVars = {
    portalParceiro,
    pagina,
    ...(!filter.plate.includes(',') && filter.plate && { placa: filter.plate }),
    ...(filter.plate && filter.plate.length !== 0 && { placas: getPlacas(filter.plate) }),
    ...(!!filter.periodo && { periodo: filter.periodo.toString() }),
    ...(filter.type &&
      filter.type.some(item => item.tipo === 'VALE_PEDAGIO') && {
        valePedagio: '1'
      }),
    ...(filter.type && {
      transacoes: getTipoTransacao(filter.type)
    }),
    ...(filter.diaDaSemana
      ? { diaDaSemana: filter.diaDaSemana.toString() }
      : { diaDaSemana: '0,1,2,3,4,5,6' }),
    ...(hasRangeDates && {
      startSqlDateFilter: moment(filter.rangeDates.from).format('YYYY-MM-DD'),
      endSqlDateFilter: moment(filter.rangeDates.to).format('YYYY-MM-DD')
    })
  }

  function getPlacas(placas) {
    let arrayPlacas = placas.split(',')

    arrayPlacas = arrayPlacas.map(function(placa) {
      return { placa: placa }
    })

    return arrayPlacas
  }

  const transacaoes = transformExtrato(
    await gqlQuery(gqlExtrato, {
      idConta: planId,
      quantidade: filter.quantidade ? filter.quantidade : QTD,
      ...gqlVars
    })
  )

  const { transacoes, enviarExtratoEmail } = transacaoes
  // O serviço não retorna a quantidade de páginas, se vier a quantidade solicitada, considera que tem mais uma página
  const nextAttrs = { hasNext: 1, next: { pagina: pagina + 1 } }

  return {
    data: transacoes || {},
    enviarExtratoEmail,
    ...(transacoes && transacoes.length === QTD && nextAttrs)
  }
}

export async function getPlanData(plan) {
  const { id: idConta } = plan
  const { data = {} } = await gqlQuery(gqlPlanData, { idConta })

  const {
    valorMensalidade: { valor: monthlyPayment } = {},
    valorRecarga: { valor: recharge } = {},
    valorBonificacao: {
      dataFimBonificacao: bonificationEndDate,
      tipoBonificacao: bonificationType,
      valorBonificacao: bonificationVaue
    } = {}
  } = data
  return {
    monthlyPayment,
    recharge,
    bonificationEndDate,
    bonificationVaue,
    bonificationType
  }
}

export async function getVehicles(accountId) {
  const resp = await gqlQuery(gqlIdentificadores, { idConta: accountId })
  return transformIndentificadores(resp)
}

export async function getVehiclesByNumber(identifierNumber) {
  const { data: { identificador = {} } = {} } = await gqlQuery(gqlIdentificador, {
    numero: identifierNumber
  })
  return identificador
}

export async function downloadVehiclesCSV(planId) {
  const resp = await gqlQuery(gqlDownloadIdentificadoresCsv, {
    idConta: planId
  })
  const b64File = resp.data.consultarIdentificadoresAtivos
  return downloadBase64(b64File, 'text/csv', 'identificadores.csv')
}

// TODO IMPLEMENTAR !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export async function downloadInvoice(planId, year, month) {
  // const resp = await gqlQuery(gqlDownloadFaturaPdf, { idConta: planId })
  // const b64File = resp.data.download.result
  // return downloadBase64(b64File, 'application/pdf', 'fatura.pdf')
}

export async function resendStatement(fastId) {
  const response = await gqlMutate(gqlResendStatement, { fastId })
  return response
}

export async function downloadStatementCSV(planId, filter = {}) {
  const hasRangeDates = filter.rangeDates && filter.rangeDates.from && filter.rangeDates.to
  const gqlVars = {
    ...(filter.plate && { placa: filter.plate }),
    ...(filter.placas && filter.placas.length !== 0 && { placas: filter.placas }),
    ...(!!filter.periodo && { periodo: filter.periodo.toString() }),
    ...(filter.type &&
      filter.type.some(item => item.tipo === 'VALE_PEDAGIO') && {
        valePedagio: '1'
      }),
    ...(filter.type && {
      transacoes: getTipoTransacao(filter.type)
    }),
    ...(filter.diaDaSemana
      ? { diaDaSemana: filter.diaDaSemana.toString() }
      : { diaDaSemana: '0,1,2,3,4,5,6' }),
    ...(hasRangeDates && {
      startSqlDateFilter: moment(filter.rangeDates.from).format('YYYY-MM-DD'),
      endSqlDateFilter: moment(filter.rangeDates.to).format('YYYY-MM-DD')
    })
  }
  const resp = await gqlQuery(gqlDownloadExtratoCsv, {
    idConta: planId,
    ...gqlVars
  })
  const b64File = resp.data.extratoCSV.result
  return downloadBase64(b64File, 'text/csv', 'extrato.csv')
}

export async function downloadStatement(planId, filter = {}) {
  const hasRangeDates = filter.rangeDates && filter.rangeDates.from && filter.rangeDates.to
  const gqlVars = {
    ...(filter.plate && { placa: filter.plate }),
    ...(filter.placas && filter.placas.length !== 0 && { placas: filter.placas }),
    ...(!!filter.periodo && { periodo: filter.periodo.toString() }),
    ...(filter.type &&
      filter.type.some(item => item.tipo === 'VALE_PEDAGIO') && {
        valePedagio: '1'
      }),
    ...(filter.type && {
      transacoes: getTipoTransacao(filter.type)
    }),
    ...(filter.diaDaSemana
      ? { diaDaSemana: filter.diaDaSemana.toString() }
      : { diaDaSemana: '0,1,2,3,4,5,6' }),
    ...(hasRangeDates && {
      startSqlDateFilter: moment(filter.rangeDates.from).format('YYYY-MM-DD'),
      endSqlDateFilter: moment(filter.rangeDates.to).format('YYYY-MM-DD')
    })
  }

  const resp = await gqlQuery(gqlDownloadExtratoPdf, {
    idConta: planId,
    ...gqlVars
  })
  const b64File = resp.data.download.result
  return downloadBase64(b64File, 'application/pdf', 'extrato.pdf')
}

export async function downloadFatura(planId, invoiceId) {
  const resp = await gqlQuery(gqlDownloadFaturaPdf, {
    idConta: planId,
    numeroFatura: parseInt(invoiceId, 10)
  })
  const b64File = resp.data.downloadFaturaPdf && resp.data.downloadFaturaPdf.result
  if (!b64File) {
    const err = new Error('Erro ao baixar fatura')
    err.status = 404
    throw err
  }
  return downloadBase64(b64File, 'application/pdf', 'fatura.pdf')
}

export async function downloadCSVInvoice(planId, invoiceId) {
  const resp = await gqlQuery(gqlDownloadFaturaCsv, {
    idConta: planId,
    numeroFatura: parseInt(invoiceId, 10)
  })
  const b64File = resp.data.downloadFatura && resp.data.downloadFatura.result
  if (!b64File) {
    const err = new Error('Erro ao baixar fatura')
    err.status = 404
    throw err
  }
  return downloadBase64(b64File, 'text/csv', 'fatura.csv')
}

export async function downloadTicket(planId, nsu) {
  const resp = await gqlQuery(gqlDownloadBoleto, {
    idConta: planId,
    nsu: parseInt(nsu, 10)
  })
  let b64File = null
  let errObj = null
  const result = resp.data.downloadBoleto && resp.data.downloadBoleto.result
  try {
    errObj = JSON.parse(result)
  } catch (e) {
    b64File = result
  }
  if (errObj) {
    const err = new Error(errObj.message)
    err.statusCode = errObj.statusCode
    throw err
  }
  if (b64File) downloadBase64(b64File, 'application/pdf', 'boleto.pdf')
}

export async function sendStatementEmail(planId, email, filter = {}, formato) {
  const hasRangeDates = filter.rangeDates && filter.rangeDates.from && filter.rangeDates.to
  const gqlVars = {
    ...(filter.plate && { placa: filter.plate }),
    ...(filter.placas && filter.placas.length !== 0 && { placas: filter.placas }),
    ...(filter.month && { mes: filter.month }),
    ...(filter.year && { ano: filter.year }),
    ...(!!filter.periodo && { periodo: filter.periodo.toString() }),
    ...(filter.type &&
      filter.type.some(item => item.tipo === 'VALE_PEDAGIO') && {
        valePedagio: '1'
      }),
    ...(filter.type && {
      transacoes: getTipoTransacao(filter.type)
    }),
    ...(filter.diaDaSemana
      ? { diaDaSemana: filter.diaDaSemana.toString() }
      : { diaDaSemana: '0,1,2,3,4,5,6' }),
    ...(hasRangeDates && {
      startSqlDateFilter: moment(filter.rangeDates.from).format('YYYY-MM-DD'),
      endSqlDateFilter: moment(filter.rangeDates.to).format('YYYY-MM-DD')
    })
  }

  const resp = await gqlQuery(gqlSendStatementEmail, {
    idConta: planId,
    email,
    formato,
    ...gqlVars
  })

  return resp
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/dashboardService.js